import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { apiUrl } from "@/api/api";
import { Link } from "react-router-dom";
import { Persona } from "@/api/personas";
import { QuickCreatePersonaModal } from "@/components/createPersona/QuickCreatePersonaModal";
import { Bot } from "lucide-react";

interface SuccessScreenProps {
  isVisible: boolean;
  persona?: Persona;
}

const SuccessScreen: React.FC<SuccessScreenProps> = ({
  isVisible,
  persona,
}) => {
  const [isQuickPopulateOpen, setIsQuickPopulateOpen] = useState(false);

  if (!isVisible || !persona) return null;

  const handleQuickPopulateSuccess = (updatedPersona: Persona) => {
    console.log("AI Population successful on SuccessScreen:", updatedPersona);
    setIsQuickPopulateOpen(false);
  };

  return (
    <>
      <div className="fixed inset-0 z-50 flex items-center justify-center">
        <div className="absolute inset-0 bg-black bg-opacity-80 backdrop-filter backdrop-blur-xl"></div>

        <div className="relative z-10 flex flex-col items-center justify-center text-center px-6 max-w-md w-full">
          <div className="mb-4 text-4xl">🎉</div>

          <h2 className="text-4xl font-bold text-[#c8ff00] mb-2">
            AGENT CREATED
          </h2>
          <p className="text-white text-lg mb-10">
            Your agent has been successfully created
          </p>

          <div className="mb-8 flex flex-col items-center">
            <div className="w-24 h-24 rounded-full overflow-hidden border-2 border-[#c8ff00] mb-3">
              {persona.avatar_id ? (
                <img
                  src={`${apiUrl}/get-file?url=persona-knowledge-base/${persona.persona_id}/${persona.avatar_id}`}
                  alt={persona.name}
                  className="w-full h-full object-cover"
                />
              ) : (
                <div className="w-full h-full bg-gray-700 flex items-center justify-center">
                  <span className="text-white text-2xl">
                    {persona.name.charAt(0)}
                  </span>
                </div>
              )}
            </div>
            <h3 className="text-white text-xl font-semibold">{persona.name}</h3>
          </div>

          <div className="flex flex-col items-center gap-4">
            <Link to={`/agents/${persona.persona_id}/edit`}>
              <Button className="py-3 px-8 text-lg font-semibold bg-[#c8ff00] text-black hover:bg-[#a8df00] rounded-full w-64">
                TRAIN YOUR AGENT
              </Button>
            </Link>

            <Button
              variant="outline"
              className="py-3 px-8 text-lg font-semibold text-[#c8ff00] border-[#c8ff00] hover:bg-[#c8ff00]/10 hover:text-[#c8ff00] rounded-full w-64"
              onClick={() => setIsQuickPopulateOpen(true)}
            >
              <Bot className="mr-2 h-5 w-5" />
              AI QUICK CREATE
            </Button>
          </div>
        </div>
      </div>

      <QuickCreatePersonaModal
        isOpen={isQuickPopulateOpen}
        onClose={() => setIsQuickPopulateOpen(false)}
        onSuccess={handleQuickPopulateSuccess}
        personaId={persona?.persona_id}
        personaName={persona?.name}
        currentPersonaData={persona}
      />
    </>
  );
};

export default SuccessScreen;
